/*
 * Copyright (C) Whirl Software PTE LTD. 2014-2017 - All Rights Reserved
 * 600 North Bridge Road, Parkview Square #15-10, Singapore
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * License: see file “LICENSE.txt”
 */
const { angular } = window;

angular
  .module('wcm.auth')
  .factory('authInterceptor', function($q, $location, $rootScope, $injector) {
    const responseError = function responseError(rejection) {
      if (rejection.status === 496) {
        const session = $injector.get('session');
        session.destroy();
        $location.path('/login');
      }
      return $q.reject(rejection);
    };
    return {
      responseError
    };
  });
